<template>
    <van-dialog
        v-model="showDialog"
        width="2.8rem"
        :title="i18n.t('confirmLogout')"
        :message="i18n.t('logoutTips')"
        :confirm-button-text="i18n.t('logout')"
        overlay-class="nav-header-logout"
        showCancelButton
        @confirm="onConfirm"
        @cancel="onCancel"
    ></van-dialog>
</template>

<script>
import { Logout } from '@/apis/modules/uc'
import { isInRyH5 } from '@/utils'
import { i18n } from '../i18n'

export default {
    props: {
        show: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        showDialog: {
            get() {
                return this.show
            },
            set(val) {
                this.$emit('update:show', val)
            },
        },
        isInFinone() {
            return sessionStorage.getItem('isInFinOne') === '1'
        },
    },
    data() {
        return {
            i18n,
        }
    },
    methods: {
        async onConfirm() {
            Logout()
                .then(() => {
                    this.handleData()
                })
                .catch(err => {
                    this.$toast(err.error.message)
                })
                .finally(() => {
                    this.showDialog = false
                })
        },
        // 退出登录成功处理
        handleData() {
            localStorage.removeItem('uin')
            localStorage.removeItem('session')
            localStorage.removeItem('rndKey')
            const queryStr = isInRyH5() && !this.isInFinone ? '?isInRy=1&bizSource=ruiyin' : this.isInFinone ? '?bizSource=finfo' : ''
            window.location.href = '/pages/login.html#/' + queryStr
        },
        onCancel() {
            this.showDialog = false
        },
    },
}
</script>

<style lang="less">
@import '../styles/index.less';

.nav-header-contact + .van-dialog {
    .van-dialog-style();
}
</style>
